// src/types/app-events.ts
export enum AppEvents {
  PlayerPauseAndQuiesce = 'appPlayerPauseQuiesce',
  PlayerMaybeResumeOrRestore = 'appPlayerResumeOrRestore',
  PlayerStop = 'appPlayerStop',
}